import { TransactionTagType } from '@pre-accounting/enums/transactions/transaction-tag-type.enum';

export interface TransactionTagJson {
  id: number;
  has_label: boolean;
  name: string;
  type: TransactionTagType;
  amount: number;
}

export class TransactionTag {
  constructor(
    public id: number,
    public hasLabel: boolean,
    public name: string,
    public type: TransactionTagType,
    public amount: number
  ) {}

  static fromJson(json: Partial<TransactionTagJson>): TransactionTag {
    return new TransactionTag(json.id, json.has_label, json.name, json.type, json.amount);
  }

  static toJson(model: TransactionTag): Partial<TransactionTagJson> {
    return {
      id: model.id,
      has_label: model.hasLabel,
      name: model.name,
      type: model.type,
      amount: model.amount
    };
  }
}
